import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-key-value-block',
  templateUrl: './key-value-block.component.html',
  styleUrls: ['./key-value-block.component.scss'],
})
export class KeyValueBlockComponent  {
  private _key = "";
  @Input() set key(key: string | null) {
    if(!key) return;
    this._key = key;
  }
  get key() {
    return this._key;
  }

  private _value = "";
  @Input() set value(value: string | null) {
    if(!value) return;
    this._value = value;
  }
  get value() {
    return this._value;
  }

  @Input() bgColor?: string;
  @Input() copyToClipboard = false;
}
